module.exports = __webpack_public_path__ + "img/Evaluation Process_01.302ecfb0.jpg";